'use client';

import { observer } from 'mobx-react-lite';
import Image from 'next/legacy/image';
import IconSymplaPlay from '@sympla/sympla-ui/lib/icons/iconSymplaPlay';
import { SearchEvent } from 'searchEvent.d';
import { DEFAULT_IMAGE } from 'constants/index';
import * as styles from './EventOndemandCard.css';

type EventOndemandCardProps = {
  hasPriority?: boolean;
} & SearchEvent;

function EventOndemandCard({
  name,
  images,
  url,
  organizer,
  hasPriority,
}: EventOndemandCardProps) {
  return (
    <a href={url} className={styles.card}>
      <Image
        src={images?.xs || DEFAULT_IMAGE}
        alt={`Banner ${name}`}
        width={264}
        height={134}
        priority={hasPriority}
      />
      <div className={styles.infoContainer}>
        <div className={styles.logoWrapper}>
          <IconSymplaPlay height={24} width={81} />
        </div>
        <h3>{name}</h3>
        <p className={styles.location}>{`Por ${organizer?.name}`}</p>
      </div>
    </a>
  );
}

export default observer(EventOndemandCard);
